import {
  UNAUTH_USER

} from '../actions/errorsActions';


const initialState = {
  show:false

} // END initialState


export default function(state = initialState, action){
  switch(action.type){
    case(UNAUTH_USER):
      return {show:true};

    default:
      break;

  } // END switch

  return state;

} // END default


// WEBPACK FOOTER //
// ./src/redux/reducers/errorsReducer.js